import React, { useEffect, useState } from 'react';
import CustomTable from '../../../../../components/Tables/CustomTable';
import { INDICATOR_TYPE_PROCESS } from '../../../../../utils/const';
import { Subdimensiones } from '../../../../../interfaces/Evaluations';
import { useAppSelector } from '../../../../../redux/hooks';
import MobileTableResAndProc from '../Tables/MobileTableResAndProc';
import SubdimensionsResAndProc from '../../../utils/SubdimensionLink';
import EvaluationStatesCircle from '../../../../../components/States/EvaluationStatesCircle';

const EvaluationSubdimensionResAndProc = ({ selected_type_indicator, evaluation_subDimension }: { selected_type_indicator: { name: string, id: number }, evaluation_subDimension: Subdimensiones[] }) => {
    const { selected_dimension } = useAppSelector((state) => state.evaluator)

    const [right, setRight] = useState('');
    const [rightId, setRightId] = useState('');
    const [period, setPeriod] = useState('');

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const params = new URLSearchParams(window.location.search);

            setRight(params.get('right') || '');
            setRightId(params.get('rightId') || '');
            setPeriod(params.get('periodo') || '')
        }
    }, []);

    const columns: { label: string; accessor: keyof Subdimensiones; render?: (value: any, row: Subdimensiones) => React.ReactNode }[] = [
        {
            label: 'Subdimensiones',
            accessor: 'nombre',
            render: (value: string, row: Subdimensiones) => (
                <SubdimensionsResAndProc
                    selected_dimension={selected_dimension}
                    selected_type_indicator={selected_type_indicator}
                    period={period}
                    value={value}
                    subdimension={row}
                    right={right}
                    rightId={rightId}
                />
            )
        },
        {
            label: 'Indicadores',
            accessor: 'indicadores',
            render: (value: Subdimensiones['indicadores']) => (
                <span className='text-system-light-40'>{value?.length}</span>
            )
        },
        {
            label: 'Estado',
            accessor: 'trivalente_subdimension',
            render: (value: Subdimensiones['trivalente_subdimension']) => (
                <div className='flex justify-center'>
                    <EvaluationStatesCircle
                        status={value}
                        size={12}
                    />
                </div>
            )
        },
    ];

    return (
        <div className='mt-6'>
            <div className="block md:hidden">
                <MobileTableResAndProc
                    selected_dimension={selected_dimension}
                    selected_type_indicator={selected_type_indicator}
                    period={period}
                    evaluation_subDimension={evaluation_subDimension}
                    right={right}
                    rightId={rightId}
                    bgColorHeader={selected_type_indicator.name === INDICATOR_TYPE_PROCESS ? 'bg-primary-200' : 'bg-[#FFBD8B]'}
                />
            </div>
            <div className="hidden md:block">
                <CustomTable
                    columns={columns}
                    data={evaluation_subDimension}
                    colorTr={selected_type_indicator.name === INDICATOR_TYPE_PROCESS ? 'text-primary-100' : 'text-primary-10'}
                    bgColorTr={selected_type_indicator.name === INDICATOR_TYPE_PROCESS ? 'bg-primary-200' : 'bg-[#FFBD8B]'}
                />
            </div>
            <div className='mt-10'></div>
        </div>
    );
}

export default EvaluationSubdimensionResAndProc;